import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content-core/structured-content';
import baseStyles from '@nerdwallet/base-styles/react';
import Container from '@nerdwallet/react-container';
import { NativeType as Type } from '@nerdwallet/currency';
import { AnchorContextProvider } from './contexts/AnchorContext';
import { MarketplaceContextProvider } from './contexts/MarketplaceContext';

/**
 * StructuredContentWrapper Component
 * - default renders Primitives in <Type />
 * - wraps core StructuredContent in a clearfix Container unless noClearFix prop is set
 * - wraps core StructuredContent with AnchorContextProvider
 *   - this is to scope all AnchorLink/AnchorLinkTarget types to only this document by default
 *   - use <AnchorContextProvider> in your application to tie together AnchorLink/AnchorLinkTargets in multiple documents
 * - wraps core StructuredContent with MarketplaceContextProvider
 *   - this is to provide access to the marketplace context to grab loaded marketplace entities for OODMessage
 */
var StructuredContentWrapper = function StructuredContentWrapper(_ref) {
  var noClearFix = _ref.noClearFix,
      props = _objectWithoutProperties(_ref, ["noClearFix"]);

  var containerProps = baseStyles('clearfix');

  if (noClearFix) {
    containerProps = {};
  }

  return /*#__PURE__*/React.createElement(Container, containerProps, /*#__PURE__*/React.createElement(AnchorContextProvider, null, /*#__PURE__*/React.createElement(MarketplaceContextProvider, null, /*#__PURE__*/React.createElement(StructuredContent, props))));
};

StructuredContentWrapper.propTypes = _objectSpread(_objectSpread({}, StructuredContent.propTypes), {}, {
  noClearFix: PropTypes.bool
});
StructuredContentWrapper.defaultProps = _objectSpread(_objectSpread({}, StructuredContent.defaultProps), {}, {
  Primitive: Type,
  noClearFix: false
});
export default StructuredContentWrapper;